<!-- ATTN: this is a controller-only component, no template. Adds features to the map. -->
<nav class="bottom right vertical">
    <section class="bar vertical">
        <button (click)="resetZoom.emit()" (keydown.enter)="resetZoom.emit()">
            <img [src]="icons.home" />
        </button>
        <button [disabled]="map.getZoom() >= map.getMaxZoom()" (click)="zoomIn()" (keydown.enter)="zoomIn()">+</button>
        <button [disabled]="map.getZoom() <= map.getMinZoom()" (click)="zoomOut()" (keydown.enter)="zoomOut()">
            −
        </button>
    </section>
</nav>

<nav class="bottom left horizontal" *ngIf="isEditable">
    <section class="bar horizontal">
        <button (click)="requestToggleEditing()" (keydown.enter)="requestToggleEditing()" *ngIf="!isEditing">
            <img [src]="icons.edit" />
        </button>
        <ng-container *ngIf="isEditing">
            <input style="display: none" type="file" (change)="addImg($event.target)" #fileUpload />
            <button class="wide" (click)="cancelChanges()" (keydown.enter)="cancelChanges()">CANCEL</button>
            <!-- <button (click)="fileUpload.click()" (keydown.enter)="fileUpload.click()">
                <img [src]="icons.image" />
            </button> -->
            <!-- <button (click)="requestSelectFeature()" (keydown.enter)="requestSelectFeature()">
                <img [src]="icons.add" />
            </button> -->
            <button class="wide" (click)="saveChanges()" (keydown.enter)="saveChanges()">SAVE</button>
        </ng-container>
    </section>
</nav>
